import { CHATBOT_TOKEN_USER } from '../utils/constants';

export const getTokenUserFromCookieChatbot = () => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const trimmedCookie = cookie.trim();
        const index = trimmedCookie.indexOf('=');
        if (index > -1) {
            const name = trimmedCookie.substring(0, index);
            const value = trimmedCookie.substring(index + 1);
            if (name === CHATBOT_TOKEN_USER) {
                return decodeURIComponent(value);
            }
        }
    }
    return null;
};
